import { useState } from 'react'

import Historico from '@/components/form/historico-modificacao'

import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from '@/components/ui/select'

import { useCurrentUser } from '@/features/auth/state/auth'

import { ProdutosStatus } from '@/lib/enums'

import { friendlyNameMaps } from '@/components/form/input/StatusMapper'
import ObservartionCliente from '../../../client/components/observation-cliente'
import SubventionTable from '../subvencao/tabela-subvencao'
import { Product } from '../../state/selectProduct'
// Função para copiar o texto para a área de transferência

type subversionProps = {
  cnpj?: string // Prop opcional para receber o CNPJ
  product: Product
}

export default function Subvencao({ cnpj, product }: subversionProps) {
  const [selectedStatus, setSelectedStatus] = useState<ProdutosStatus>('ATIVO' as ProdutosStatus) // product.status
  const user = useCurrentUser()

  return (
    <div className="min-h-full bg-background-secondary rounded-lg text-foreground p-2 space-y-2 relative">
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
        <h1 className="text-2xl font-bold text-foreground">Subvenção</h1>
      </div>
      <div className="grid  sm:grid-cols-2 w-screen ml-5">
        {/* Status */}
        <div className="grid grid-cols-2 ml-2">
          <div>
            <label className=" text-sm text-foreground block ">Status</label>
            <Select
              disabled={user?.typeUser === 'USUARIO'}
              value={selectedStatus} // Define o valor atual como o estado `selectedStatus`
              onValueChange={value => setSelectedStatus(value as ProdutosStatus)} // Atualiza o estado ao selecionar
            >
              <SelectTrigger className="max-w-72 border-primary">
                <SelectValue placeholder="Selecione o status">
                  {friendlyNameMaps.produtosStatus[selectedStatus] ?? selectedStatus}
                </SelectValue>
              </SelectTrigger>
              <SelectContent className="bg-background">
                {Object.entries(friendlyNameMaps.produtosStatus).map(([key, label]) => (
                  <SelectItem key={key} value={key}>
                    {label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>
      <div className="p-4 flex justify-center items-center shadow-xl">
        <SubventionTable />
      </div>
      <div className="p-4 flex justify-center items-center shadow-xl">
        <Historico type="SUBVENCAO" productId={product.id} />
      </div>
      <div className="p-4 flex justify-center items-center shadow-xl">
        <ObservartionCliente type={'SUBVENCAO'} cnpj={cnpj ?? ''} id={product.id} />
      </div>
    </div>
  )
}
